// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle/squadbusters/" + chunkId + "." + {"322":"78074fa1f074a83b2ccd","496":"ce9277c98157280e064d","572":"a8b8587549e073452e57","582":"2385312ec4cb5db93ebf","677":"9ac88f6de6589dbf3811","819":"483e828c01500726ae1f","869":"43cfb36c39c781e71f19","874":"2b3a68361ddae9e19c7d","964":"4e037c4ec0f7ca93bfc5"}[chunkId] + ".min.js";
};